{
  "colorPicker": "Color picker",
  "twoDimensionalSlider": "2D slider",
  "colorNameAndValue": "{name}: {value}",
  "colorInputLabel": "{label}, {channelLabel}"
}
